import classNames from 'classnames';
import { TableCellProps } from '@servicetitan/table';
import { FC } from 'react';

import { Button, Icon } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';

import { PhoneNumbersStore } from '../stores/phone-numbers.store';
import * as Styles from './phone-numbers-action-cell.module.less';

export const PhoneNumbersActionCell: FC<TableCellProps<any>> = ({ tableState, dataItem }) => {
    const [store] = useDependencies(PhoneNumbersStore);
    if (!tableState) {
        return <td />;
    }

    const handleEdit = () => {
        tableState.cancelEditAll();
        tableState.edit(dataItem);
        store.openEditModal(dataItem);
    };

    return (
        <td className="action-buttons-td">
            {!dataItem.inEdit && (
                <Button
                    xsmall
                    className={classNames(Styles.actionButtonMargin, 'action-buttons-group')}
                    onClick={handleEdit}
                    data-cy={`action-button-phone-number-${dataItem.friendlyName}`}
                >
                    <Icon name="edit" />
                </Button>
            )}
        </td>
    );
};
